/**
 * GAME_END — match is fully over. Final results, no more rolls.
 *
 * Cleanup-only state: hide all betting UI, clear dice from the table,
 * keep profile cards visible so players can see final balances.
 * Late joiners (animated:false) just see the final state via
 * _checkPlayers + _updateProfiles.
 */

import type { GameUpdate } from '@sdl/shared';
import { State } from '../State.js';

export class GameEndState extends State {
  async onEnter(update: GameUpdate): Promise<void> {
    const game = this.game;

    // Guarantee the shooting baseline (lights + betting teardown) — a match can
    // end out of a betting phase, and only roll states call exitBettingMode.
    // Idempotent on every other path.
    game.ensureShootingView();

    game.playerProfilesOverlay?.show();
    game.playerProfilesOverlay?.setMode('shooting');
    game.bettingHUD3D?.setLockInVisible(false);
    game.countdownOverlay?.stop();
    game.instructionBanner?.hide();

    // Final cleanup: dice off the table, opponents reset.
    game.diceController?.clearDice();
    game.cameraController?.setDice([]);
    game.cameraController?.setMode('default');
    game.opponentDiceManager?.resetAllOpponents();
    game.opponentDiceManager?.hideAllResultLabels();

    this._updateProfiles(update);
    await this._checkPlayers(update);
  }

  async onUpdate(update: GameUpdate): Promise<void> {
    this._updateProfiles(update);
    await this._checkPlayers(update);
  }
}
